// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Wallets from './Wallets';

export default compose(
    connect(
        state => ({
            user: state?.global?.user || [],
        }),
        dispatch => ({}),
    ),
)(Wallets);
